import { UPDATE_MEDIA_LOGO } from '../apis/workspace';
import APOLLO_CLIENT from '../lib/apollo';
import { API_DOMAIN } from '../constants/config';

// upload file to endpoint using presigned url
export const uploadFileToEndpoint = async ({ path, blob, fileType, body }) => {
  try {
    const file = new File([blob], `logo.${fileType}`, { type: `image/${fileType}` });
    const formData = new FormData();
    formData.append('filename', file);
    Object.keys(body).forEach((key) => {
      formData.append(key, body[key]);
    });
    await fetch(`${API_DOMAIN}${path}`, {
      method: 'POST',
      body: formData,
    });
  } catch (error) {
    throw new Error('Something went wrong while uploading Avatar!');
  }
};

// Upload Workspace Avatar
// Steps:
// 1. Generate S3 link for the avatar
// 2. Upload the avatar to the generated link
// 3. Update the workspace logo with the new avatar path to s3
export const uploadWorkspaceAvatar = async ({ workspaceLogo, workspaceId }) => {
  if (workspaceLogo.blob) {
    try {
      const { blob, type: fileType } = workspaceLogo;
      const variables = {
        type: 'workspace',
        fileType,
        workspaceId,
      };
      await uploadFileToEndpoint({ path: '/upload/workspace', blob, fileType, body: { workspaceId } });
      const { data: { updateMediaLogo: { logo } } } = await APOLLO_CLIENT.mutate({ mutation: UPDATE_MEDIA_LOGO, variables, context: { headers: { Authority: workspaceId } } });
      return logo;
    } catch (error) {
      throw new Error('Something went wrong while uploading Avatar!');
    }
  } return null;
};

// Upload Workspace Profile Avatar
// Steps:
// 1. Generate S3 link for the avatar
// 2. Upload the avatar to the generated link
// 3. Update the workspace profile logo with the new avatar path to s3
export const uploadWorkspaceProfileAvatar = async ({ workspaceProfileLogo, workspaceProfileId, userId, workspaceId }) => {
  if (workspaceProfileLogo.blob) {
    try {
      const { blob, type: fileType } = workspaceProfileLogo;
      const variables = {
        type: 'user',
        fileType,
        userId: parseInt(userId, 10),
        workspaceProfileId,
        workspaceId,
      };
      await uploadFileToEndpoint({ path: '/upload/profile', blob, fileType, body: { userId, workspaceProfileId } });
      const { data: { updateMediaLogo: { logo } } } = await APOLLO_CLIENT.mutate({ mutation: UPDATE_MEDIA_LOGO, variables, context: { headers: { Authority: workspaceId } } });
      return logo;
    } catch (error) {
      throw new Error('Something went wrong while uploading Avatar!');
    }
  } return null;
};
